// extracted by mini-css-extract-plugin
module.exports = {"profileCard":"CardCountry_profileCard__DwtK7","header":"CardCountry_header__Jmisw","img":"CardCountry_img__q_6AM"};